module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("ICP for 05052060")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1708380","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom-text.vue
// module id = 804
// module chunks = 0 10 11 12 13 14 15 16